export default {
    HTTP_URL: '',
    ADMIN_URL: '',
    BUILDER_SEARCH_ENABLED: false,
};
